import { QUERY_KEYS } from 'api/query-keys';
import { NavigationKey } from 'hq/components/sidebar/sidebar-items.types';
import { partnerNotificationService } from 'partner/shared/services';
import { GetPartnerNotificationsResponse } from 'partner/shared/services/partner-notification-service.types';
import { useQuery } from 'react-query';

export const useGetPartnerNotification = () => {
  const queryFn = async () => await partnerNotificationService.getPartnerNotifications();

  return useQuery({ queryKey: QUERY_KEYS.notifications(), queryFn, select });
};

const select = (data: GetPartnerNotificationsResponse): Record<NavigationKey, number> => {
  return {
    inbox: data.inbox,
    checkouts: data.checkouts,
  };
};
